var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.96 51.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m43.47,51.8c0-9.09-7.4-16.49-16.48-16.49s-16.48,7.4-16.48,16.49H0c0-14.88,12.1-26.98,26.98-26.98,14.88,0,26.98,12.1,26.98,26.98h-10.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.5,8.25c0,9.09,7.4,16.49,16.48,16.49,9.09,0,16.48-7.4,16.48-16.49h10.5c0,14.88-12.1,26.98-26.98,26.98C12.1,35.23,0,23.13,0,8.25h10.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 26.98,
    cy: 8.25,
    r: 8.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco);
export default __webpack_public_path__ + "static/media/ico.d11ceb35a0639a23d861c4b57b9859d6.svg";
export { ForwardRef as ReactComponent };